import {
  GetSimulatedTestQuestions_URL,
  POST_METHOD,
  SendChallengeHistory_URL,
  SendChallengeRequest_URL,
  Submit_Simulated_Test_Response,
} from '../../Apis/api';

export const fetchQuestionsForSimulatedTest = (responseData) => {
  return fetch(GetSimulatedTestQuestions_URL, {
    method: POST_METHOD,
    body: JSON.stringify(responseData),
  }).then((response) => {
    return response.json();
  });
};

export const submitSimulatedTestResult = (simulated_test_score_body) => {
  return fetch(Submit_Simulated_Test_Response, {
    method: POST_METHOD,
    body: JSON.stringify(simulated_test_score_body),
  }).then((response) => {
    return response.json();
  }).catch((e) => {
    // alert(JSON.stringify(e))
  });
};

export const submitChallengeRequestAPI = (submit_challenge_request_body) => {

  return fetch(SendChallengeRequest_URL, {
    method: POST_METHOD,
    body: JSON.stringify(submit_challenge_request_body),
  }).then((response) => {

    return response.json();
  }).catch((e) => {

    // alert(JSON.stringify(e))
  });
};

export const submitChallengeHistoryAPI = (submit_challenge_history_body) => {
  return fetch(SendChallengeHistory_URL, {
    method: POST_METHOD,
    body: JSON.stringify(submit_challenge_history_body),
  }).then((response) => {
    return response.json();
  }).catch((e) => {
    // alert(JSON.stringify(e))
  });
};
